import type { ContactFormConfirm } from '@monorepo/common';
import { atom, useAtom } from 'jotai';

const contactReplyAtom = atom({
  body: '',
  files: [] as Array<File>,
});

const useContactReplyAtom = () => useAtom(contactReplyAtom);

const contactAtom = atom<ContactFormConfirm>({
  selectCategory: { id: 0, name: '' },
  name: '',
  email: '',
  description: '',
  files: [],
});

const useContactAtom = () => useAtom(contactAtom);

export { useContactReplyAtom, useContactAtom };
